import api from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import { BASE_PORTAL_EMAIL_ADDRESSES_QUERY_KEY } from "@/services/queryKeys"

type ListPortalEmailAddressesOut = Array<string>

export const listPortalEmailAddresses =
  async (): Promise<ListPortalEmailAddressesOut> => {
    const response =
      await api.get<ListPortalEmailAddressesOut>(
        "/auth/portal/email-addresses"
      )

    return response.body
  }

export const usePortalEmailAddresses = () =>
  useQuery(
    [BASE_PORTAL_EMAIL_ADDRESSES_QUERY_KEY],
    listPortalEmailAddresses
  )
